/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FixedGradeAvailabilityParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('fixed')],
    ['value', codecBoolean],
]);
export class FixedGradeAvailability extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FixedGradeAvailabilityParser.decode(input).map(res => new FixedGradeAvailability(res));
    }
    static unsafeDecode(input) {
        return FixedGradeAvailability.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FixedGradeAvailabilityParser.encode(data);
    }
    static schema() {
        return FixedGradeAvailabilityParser.schema();
    }
}
